import { Button } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import "./index.less";
import logo_isefc from "../../../assets/images/logo_isefc_black.png";

function IsefcHeader() {
  return (
    <div className="header">
      <div className="container top">
        <div className="left">
          <a
            href="http://www.isefc.org/index.php/zh/" target="_blank"><img className="logo" src={logo_isefc} alt="logo" /></a>
          <span className="line"></span>
          <span className="header_title" style={{backgroundColor:"#ffffff",width:500}}>科技成果转化双推双促工程“新动能百优项目”评审系统</span>
        </div>
        <div className="right">
          <Link
            to={"/isefcLogin?identity=application"}
          >
            <Button>登录</Button>
          </Link>
        </div>
      </div>
      <div className="menu">
        <div className="container">
          <ul className="menu-list ">
            <div className="menu-item"><Link to={"/isefc"} style={{outline:"none"}}>首页</Link></div>
            <div className="menu-item"><Link to={"/isefc?screen=2"}  style={{outline:"none"}}>推介办法</Link></div>
            <div className="menu-item"><Link to={"/isefc?screen=3"}  style={{outline:"none"}}>推荐单位</Link></div>
            <div className="menu-item"><Link to={"/isefc?screen=4"}  style={{outline:"none"}}>专家委员会</Link></div>
            <div className="menu-item"><Link to={"/isefc?screen=5"}  style={{outline:"none"}}>活动之窗</Link></div>
            <div className="menu-item"><Link to={"/isefc?screen=6"}  style={{outline:"none"}}>工程简介</Link></div>
            <div className="menu-item"><Link to={"/isefcTop"} target="_blank"  style={{outline:"none"}}>新动能百优项目</Link></div>
          </ul>
        </div>
      </div>
    </div>
  );
};
export default IsefcHeader;
